import { render, staticRenderFns } from "./casing-hole.vue?vue&type=template&id=5b59a6da&scoped=true"
import script from "./casing-hole.vue?vue&type=script&lang=js"
export * from "./casing-hole.vue?vue&type=script&lang=js"
import style0 from "./casing-hole.vue?vue&type=style&index=0&id=5b59a6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59a6da",
  null
  
)

export default component.exports